<div class="action-form">
  <span class="title">{{ 'LETTING.ADVERTISMENT.HOMEQ.SET_OFFICE_HEADER' | translate }}</span>
  <p class="help-text">{{ 'LETTING.ADVERTISMENT.HOMEQ.OFFICE_INFO' | translate }}</p>
  <form>
    <div class="row">
      @if (homeQOffices?.length) {
        <div class="col-8">
          <app-autocomplete [control]="form.controls['homeQOffice']" [itemsSource]="homeQOffices"></app-autocomplete>
        </div>
      }
    </div>
    <div class="row form-group">
      <div class="col-12">
        <button class="btn btn-primary" (click)="onSubmit()" [disabled]="disableSubmit">{{ 'COMMON.SEND' | translate }}</button>
        <button class="btn link-btn ml-2" (click)="onCancel()">{{ 'CANCEL_BTN' | translate }}</button>
      </div>
    </div>
  </form>
</div>
